import { useContext, useEffect, useState } from 'react'
import Modal, { ModalBody, ModalHeader } from '../../../common/Modal'
import {
  SET_PLANT_DATA,
  SET_SELECTED_SHIFTS_DATA,
  ShiftsContext,
  SHOW_SHIFTS_FORM,
  UPDATE_CHANGE_SHIFTS_DATA,
} from '../context/context'
import SelectInput from '../../../common/SelectInput'
import { getRequest, postRequest, putRequest } from '../../../../services/base'
import InputText from '../../../common/InputText'
import Button from '../../../common/Button'
import useDebouncedValue from '../../../../utils/common_function'
import { NavContext } from '../../../../context/global_context'

const ShiftForm = ({ getShiftList = () => {} }) => {
  const [navState, navDispatch] = useContext(NavContext)
  const [state, dispatch] = useContext(ShiftsContext)
  const [searchShifts, setSearchShifts] = useState('')
  const debouncedToSearchShifts = useDebouncedValue(searchShifts, 1000)

  const getPlantList = async (search = '') => {
    let res = await getRequest(`/api/plants/?search=${search}`)
    dispatch({ type: SET_PLANT_DATA, data: res.results })
  }

  const saveShiftZone = async (e) => {
    navDispatch({
      type: 'loader',
      data: {
        caption: `Saving Plant Shifts.`,
        showLoader: true,
      },
      notification: {},
    })

    const form = e.target
    const formData = new FormData(form)
    if (state?.selectedObject?.id) {
      let res = await putRequest(
        `/api/shift/${state?.selectedObject?.id}/`,
        formData
      )

      if (res?.status) {
        navDispatch({
          type: 'notification',
          data: {
            notification_type: 'success',
            msg: 'Shift Updated Successfully',
          },
        })
        dispatch({
          type: UPDATE_CHANGE_SHIFTS_DATA,
          data: state?.selectedObject,
        })
      } else {
        navDispatch({
          type: 'notification',
          data: {
            notification_type: 'error',
            msg: res?.msg,
          },
        })
      }
    } else {
      let res = await postRequest(`/api/shift/`, formData)
      getShiftList('')
      if (res?.status) {
        navDispatch({
          type: 'notification',
          data: {
            notification_type: 'success',
            msg: 'Shift Saved Successfully',
          },
        })
        dispatch({ type: SHOW_SHIFTS_FORM, data: {}, showFormPopup: false })
      } else {
        navDispatch({
          type: 'notification',
          data: {
            notification_type: 'error',
            msg: res?.msg,
          },
        })
      }
    }
  }

  useEffect(() => {
    getPlantList(searchShifts)
  }, [debouncedToSearchShifts])

  return (
    <Modal
      onClose={() => {
        dispatch({ type: SHOW_SHIFTS_FORM, data: {}, showFormPopup: false })
      }}
      show={state.showFormPopup}
    >
      <ModalHeader className={'text-white'}>
        {state?.selectedObject?.id
          ? 'Update Existing Shift'
          : 'Create New Shift'}
      </ModalHeader>
      <ModalBody>
        <form
          onSubmit={(e) => {
            e.preventDefault()
            saveShiftZone(e)
          }}
        >
          <input
            type="hidden"
            value={state?.selectedObject?.id ? false : true}
            name="is_create"
          />
          {state?.selectedObject?.id && (
            <input type="hidden" name="id" value={state?.selectedObject?.id} />
          )}

          <div className="flex">
            <div className="w-full">
              <SelectInput
                value={state?.selectedObject?.plant}
                onChange={(value) => {
                  dispatch({
                    type: SET_SELECTED_SHIFTS_DATA,
                    data: {
                      ...state?.selectedObject,
                      plant: value,
                    },
                    showFormPopup: true,
                  })
                }}
                label="Select Plant"
                name="plant"
                isRequired={true}
                options={state?.plants}
                optionLabel={'name'}
                optionValue={'id'}
                onInputChange={(value) => {
                  setSearchShifts(value)
                }}
              />
            </div>
          </div>
          <div className="flex">
            <div className="w-full">
              <InputText
                name="name"
                type="text"
                label="Shift Name"
                value={state?.selectedObject?.name}
                onChange={(value) => {
                  dispatch({
                    type: SET_SELECTED_SHIFTS_DATA,
                    data: {
                      ...state?.selectedObject,
                      name: value,
                    },
                    showFormPopup: true,
                  })
                }}
              />
            </div>
          </div>
          <div className="flex">
            <div className="w-6/12">
              <InputText
                name="start_time"
                type="text"
                label="Start Time (HH:MM)"
                value={state?.selectedObject?.start_time}
                onChange={(value) => {
                  dispatch({
                    type: SET_SELECTED_SHIFTS_DATA,
                    data: {
                      ...state?.selectedObject,
                      start_time: value,
                    },
                    showFormPopup: true,
                  })
                }}
                pattern="[0-2]{1}[0-9]{1}:[0-5]{1}[0-9]{1}"
                isRequired={true}
              />
            </div>
            <div className="flex w-6/12">
              <InputText
                name="end_time"
                type="text"
                label="End Time (HH:MM)"
                value={state?.selectedObject?.end_time}
                onChange={(value) => {
                  dispatch({
                    type: SET_SELECTED_SHIFTS_DATA,
                    data: {
                      ...state?.selectedObject,
                      end_time: value,
                    },
                    showFormPopup: true,
                  })
                }}
                pattern="[0-2]{1}[0-9]{1}:[0-5]{1}[0-9]{1}"
                isRequired={true}
              />
            </div>
          </div>
          <div className="flex justify-end">
            <div className="w-1/4">
              <Button
                type="submit"
                className={`cursor-pointer btn my-4 px-2 w-full justify-end`}
                onClick={(e) => {}}
                value={'text'}
                text={
                  state?.selectedObject?.id ? 'Save Shift' : 'Create New Shift'
                }
              />
            </div>
          </div>
        </form>
      </ModalBody>
    </Modal>
  )
}

export default ShiftForm
